 export const PopularItems = [
    {
        id:'1',
        image:"./images/popular1.jpg",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 40% OFF FOR NEW ARRIVALS",
        category:"SUMMER SALE"
    },
    {  
        id:"2",
        image:"./images/popular2.jpg",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
        category:"AUTUMN SALE"
    },
    {  
        id:"3",
        image:"./images/popular3.jpg",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 20% OFF FOR NEW ARRIVALS",
        category:"WINTER SALE"
    },
]

 export const Categories = [
    {
        id:'1',
        image:"./images/cloth.jpg",
        category:"clothing"
    },
    {  
        id:"2",
        image:"./images/electronic.jpg",
        category:"electronics"
    },
    {  
        id:"3",
        image:"./images/furniture.jpg",
        category:"furniture"
    },
    {  
        id:"4",
        image:"./images/shoe.jpg",
        category:"shoes"
    },
]
